<div [pexDraggable]="true" position="fixed" class="pex-dialog">
    <div
        class="pex-dialog-content"
        [style.z-index]="priority + 1000"
        (click)="$event.stopPropagation()"
    >
        <ng-template #content></ng-template>
    </div>
</div>
